// Urls
export const TERMS_OF_USE_URL = 'https://www.modernhealth.com/terms-of-use';
export const CIRCLES_COMMUNITY_GUIDELINES_URL = 'https://circles.modernhealth.com/code-of-conduct';
export const PRIVACY_URL = 'https://www.modernhealth.com/privacy-notice';
